import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';
import { IAnalyticsConnectionMetadata } from '~src/settings/types/ISiteSettingsForSiteAdmin';

export interface AnalyticsConnectionOptionsForFlowResult extends IGetItemsResult {
  readonly connectionMetadataList: IAnalyticsConnectionMetadata[];
}

export class GetAnalyticsConnectionOptionsForFlowRequest extends TagRequest<{ flow_luid: string }, AnalyticsConnectionOptionsForFlowResult> {
  constructor(flowLuid: string) {
    super('analyticsextensions', 'getConnectionOptionsForFlow', { flow_luid: flowLuid });
  }
}
